module.exports = __webpack_public_path__ + "img/feature-04-zh.f17e039f.png";